import { Alert, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import legalEntities from 'modules/core/store/collections/legalEntities'

import { Description, DottedList, ListEl, Title } from './elements'

export const ExpensesV2 = () => {
  const showAEATCertified = legalEntities.main && legalEntities.main.country === 'es'
  return (
    <>
      {showAEATCertified && (
        <Alert color="highlight">
          <Text.Normal>
            <Text size="300" weight="bold">
              {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_3.concept_4')}
            </Text>
            &nbsp;
            {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_3.item_4')}
          </Text.Normal>
        </Alert>
      )}
      <Title>{i18n.t('app_store_v2.apps.expenses_v2.description_view.title_1')}</Title>
      <Description>
        {i18n.t('app_store_v2.apps.expenses_v2.description_view.description_1')}
      </Description>
      <Title>{i18n.t('app_store_v2.apps.expenses_v2.description_view.title_2')}</Title>
      <Description>
        <DottedList>
          <ListEl>
            <Text.Normal weight="bold">
              {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_2.concept_1')}
            </Text.Normal>
            &nbsp;
            {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_2.item_1')}
          </ListEl>
          <ListEl>
            <Text.Normal weight="bold">
              {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_2.concept_2')}
            </Text.Normal>
            &nbsp;
            {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_2.item_2')}
          </ListEl>
          <ListEl>
            <Text.Normal weight="bold">
              {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_2.concept_3')}
            </Text.Normal>
            &nbsp;
            {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_2.item_3')}
          </ListEl>
          <ListEl>
            <Text.Normal weight="bold">
              {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_2.concept_4')}
            </Text.Normal>
            &nbsp;
            {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_2.item_4')}
          </ListEl>
        </DottedList>
      </Description>
      <Title>{i18n.t('app_store_v2.apps.expenses_v2.description_view.title_3')}</Title>
      <Description>
        <DottedList>
          <ListEl>
            <Text.Normal weight="bold">
              {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_3.concept_1')}
            </Text.Normal>
            &nbsp;
            {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_3.item_1')}
          </ListEl>
          <ListEl>
            <Text.Normal weight="bold">
              {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_3.concept_2')}
            </Text.Normal>
            &nbsp;
            {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_3.item_2')}
          </ListEl>
          <ListEl>
            <Text.Normal weight="bold">
              {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_3.concept_3')}
            </Text.Normal>
            &nbsp;
            {i18n.t('app_store_v2.apps.expenses_v2.description_view.list_3.item_3')}
          </ListEl>
        </DottedList>
      </Description>
    </>
  )
}
